import { render, staticRenderFns } from "./ClassicAntimatterDimensionRow.vue?vue&type=template&id=482168be&scoped=true&"
import script from "./ClassicAntimatterDimensionRow.vue?vue&type=script&lang=js&"
export * from "./ClassicAntimatterDimensionRow.vue?vue&type=script&lang=js&"
import style0 from "./ClassicAntimatterDimensionRow.vue?vue&type=style&index=0&id=482168be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482168be",
  null
  
)

export default component.exports